export default __webpack_public_path__ + "static/media/desk.f89adfea.png";